import { useMutation } from 'react-query';

import { useRequest, type MutationFunction } from '@frontend/api';

import type {
  ConvertToQuoteFilesRequestBody,
  ConvertToQuoteFilesResponseBody,
} from './types';

export const convertToQuoteFilesMutationKey = [
  'parts',
  'supportingFiles',
  'convertToQuoteFiles',
];

export const useConvertToQuoteFiles: MutationFunction<
  ConvertToQuoteFilesResponseBody,
  ConvertToQuoteFilesRequestBody,
  Record<string, never>,
  []
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    (requestBody) => {
      const urlPath = `/parts/files/convert_to_quote_files`;

      return request<ConvertToQuoteFilesResponseBody>(urlPath, {
        init: {
          method: 'POST',
          body: requestBody,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: convertToQuoteFilesMutationKey,
    },
  );
};
